'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var defer = require('pull-defer/duplex');

module.exports =
/*#__PURE__*/
function () {
  function Connection(conn, info) {
    _classCallCheck(this, Connection);

    this.peerInfo = null;
    this.conn = defer();

    if (conn) {
      this.setInnerConn(conn, info);
    } else if (info) {
      this.info = info;
    }
  }

  _createClass(Connection, [{
    key: "getPeerInfo",
    value: function getPeerInfo(callback) {
      if (this.info && this.info.getPeerInfo) {
        return this.info.getPeerInfo(callback);
      }

      if (!this.peerInfo) {
        return callback(new Error('Peer Info not set yet'));
      }

      callback(null, this.peerInfo);
    }
  }, {
    key: "setPeerInfo",
    value: function setPeerInfo(peerInfo) {
      if (this.info && this.info.setPeerInfo) {
        return this.info.setPeerInfo(peerInfo);
      }

      this.peerInfo = peerInfo;
    }
  }, {
    key: "getObservedAddrs",
    value: function getObservedAddrs(callback) {
      if (this.info && this.info.getObservedAddrs) {
        return this.info.getObservedAddrs(callback);
      }

      callback(null, []);
    }
  }, {
    key: "setInnerConn",
    value: function setInnerConn(conn, info) {
      this.conn.resolve(conn);

      if (info) {
        this.info = info;
      } else {
        this.info = conn;
      }
    }
  }, {
    key: "source",
    get: function get() {
      return this.conn.source;
    }
  }, {
    key: "sink",
    get: function get() {
      return this.conn.sink;
    }
  }]);

  return Connection;
}();